var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "47px",
    viewBox: "0 0 54 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Tick/Check Icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9997-Saved-out-assets",
    transform: "translate(-1568.000000, -939.000000)",
    fill: "#212129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/green-tick",
    transform: "translate(1569.000000, 940.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9496286,0.0729541515 C46.9671518,0.0867283099 46.9842096,0.101084475 47.0007734,0.11599859 L52.537252,5.10106633 C52.9284073,5.45326414 52.9795883,6.04838515 52.6543107,6.46219695 L22.8448233,44.3852352 C22.7332431,44.5271853 22.5909496,44.6307774 22.4347786,44.6939947 L22.2878132,44.8783287 C21.9436378,45.3102567 21.3144817,45.3813941 20.8825538,45.0372187 L20.8528643,45.0126103 L20.8528643,45.0126103 L-0.235014079,26.8365773 C-0.653351173,26.4760049 -0.700178636,25.8445739 -0.339606146,25.4262368 L-0.325284657,25.4099804 L-0.325284657,25.4099804 L4.66530232,19.8673721 C5.0280755,19.4644716 5.64583033,19.4240359 6.05802765,19.7762098 L20.494,32.1093778 L45.5454535,0.241157621 C45.8867576,-0.19304272 46.5154282,-0.268349978 46.9496286,0.0729541515 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default __webpack_public_path__ + "static/media/icon_tick.97a2ff9b7613485652b21598ff244afb.svg";
export { ForwardRef as ReactComponent };